export default {
    'general': {
        'versioning': 'Versioning',
        'dashboard': 'Dashboard',
        'email': 'Email',
        'username': 'Username',
        'name': 'Name',
        'password': 'Password',
        'actions': 'Actions',
        'login': 'Login',
        'logout': 'Logout',
        'no_results': 'No results',
        'success': 'Success',
        'warning': 'Warning',
        'remember_me': 'Remember me',
        'error': 'Error',
        'edit': 'Edit',
        'details': 'Details',
        'add': 'Add',
        'delete': 'Delete',
        'yes': 'Yes',
        'no': 'No',
        'cancel': 'Cancel',
        'back': 'Back',
        'image': 'Image',
        'filters': 'Filters',
        'remove_filters': 'Remove filters',
        'default': 'Default',
        'save': 'Save',
        'key': 'Key',
        'distribution_zone': 'Distribution zone',
        'preview': 'Preview',
        'icon': 'Icon',
        'last_edited': 'Last edited',
        'users': 'users',
        'created_at': 'Created',
        'last_edited_at': 'Updated',
        'unlimited': 'Unlimited',
        'close': 'Close',
        'created_by': 'Created by',
        'last_edited_by': 'Last edited by',
        'select_option': 'Select option',
        'items_selected': 'items selected',
        'no_options': 'No available options',
        'loading': 'Loading...'
    },
    'errors': {
        'generic_error': 'There was an error',
        'login': 'There was an error logging in',
        'logout': 'There was an error logging out',
        'incorrect_password': 'The old password is incorrect',
        'username_taken': 'Username is taken',
        'invalid_data': 'Invalid data received',
        'not_found': 'Data not found',
        'user_exist': 'User with this username already exists',
        'load_data': 'There was an error loading data',
        'on_upload_image': 'There was an error uploading images',
        'on_upload_file': 'There was an error uploading files',
        'on_publish': 'There was an error while publishing',
        'on_approve': 'There was an error while approving',
        'on_download': 'There was an error while downloading file',
        'on_add': 'There was an error adding',
        'on_edit': 'There was an error editing',
        'on_delete': 'There was an error deleting',
        'on_sort': 'There was an error sorting',
        'unauthorized': 'Unauthorized',
        'user_does_not_exist': 'User does not exists',
        'no_permissions_selected': 'User must have at least one permission selected',
        'on_copy_to_clipboard': 'Error copying to clipboard',
        'default_sender_for_project_exists': 'Default sender for this project already exists',
        'allowed_outbound_email_for_project_exists': 'Email for this project already exists',
        'smtp_test_failed': 'Test email failed: {message}'
    },
    'success': {
        'on_add': 'Successfully added',
        'on_edit': 'Successfully edited',
        'on_delete': 'Successfully deleted',
        'on_publish': 'Successfully published',
        'on_approve': 'Successfully approved',
        'on_sort': 'Successfully sorted',
        'on_change_password': 'The password has been successfully changed',
        'on_copy_to_clipboard': 'Copied to clipboard!'
    },
    'confirmations': {
        'general': 'Are you sure you want to proceed?',
        'header': 'Are you sure',
        'delete_row': 'Are you sure you want to delete',
        'deactivate_row': 'Are you sure you want to deactivate',
        'publish': 'Are you sure you want to publish on',
        'approve': 'Are you sure you want to approve'
    },
    'table': {
        'no_data': 'No data to display',
        'press_enter_search': 'Press enter to search',
        'search': 'Search by',
        'select_option': 'Select option',
        'select_date': 'Select date',
        'select_range': 'Select range',
        'of': 'of'
    },
    'file': {
        'drag_and_drop': 'Drag and drop files to here to upload.'
    },
    'user': {
        'users': 'Users',
        'name': 'Name',
        'username': 'Username',
        'created': 'Created',
        'permissions': 'Permissions',
        'password': 'Password',
        'confirm_password': 'Confirm password',
        'cannot_edit_username': 'Username cannot be edited'
    },
    'project': {
        'projects': 'Projects',
        'name': 'Name',
        'max_retry_count': 'Max retry count',
        'in_development': 'In development',
        'insert_emails_limit': 'Insert into database limit',
        'send_emails_limit': 'Send emails limit',
        'insert_emails_limit_info': 'Maximum emails per minute that can be inserted into database to be sent. Maximum number of recipients per sent email request is this limit times 2. If limit is 100, then maximum number of recipients is 200.',
        'send_emails_limit_info': 'Maximum emails per minute that can be sent to recipients.',
        'is_active': 'Active',
        'project': 'Project',
        'view_api_key': 'View API key',
        'regenerate_api_key': 'Regenerate API key',
        'generate_api_key': 'Generate API key',
        'your_api_key': 'Your API key',
        'smtp_provider': 'SMTP Provider',
        'delete_key': 'Key for this project exists. Are you sure you want to delete old key and generate new?',
        'generated_key_no_access': 'You will not be able to access this key after you close this dialog!',
        'allowed_outbound_emails_are_using_this_project': 'Some allowed outbound emails are using this project',
        'force_delete': 'Are you sure you want to delete this project and all this outbound emails?'
    },
    'permissions': {
        'dashboard': 'Dashboard',
        'client_configuration': 'Client configuration',
        'configuration': 'Configuration',
        'drm_configuration': 'Drm configuration',
        'drm_global_configuration': 'Global DRM configuration',
        'drm_channel_configuration': 'Channel DRM configuration',
        'read': 'Read',
        'write': 'Write',
        'select_all': 'Select all',
        'remove_all': 'Remove all'
    },
    'allowed_outbound_email': {
        'allowed_outbound_email': 'Allowed outbound email',
        'allowed_outbound_emails': 'Allowed outbound emails',
        'name': 'Name',
        'email': 'Email',
        'default_sender': 'Default sender',
        'project': 'Project'
    },
    'smtp_provider': {
        'smtp_provider': 'SMTP Provider',
        'smtp_providers': 'SMTP Providers',
        'name': 'Name',
        'server': 'Server',
        'server_port': 'Server Port',
        'user': 'User',
        'user_password': 'User password',
        'connection_type': 'Connection Type',
        'auth_type': 'Auth type',
        'skip_tls_verify': 'Skip TLS certificate verification (insecure)',
        'is_active': 'Active',
        'send_test_email': 'Send test email',
        'test_email_sent': 'Test email sent',
        'send': 'Send'
    },
    'email': {
        'search': 'Search',
        'email': 'Email',
        'emails': 'Emails',
        'recipient': 'Recipient',
        'recipient_name': 'Recipient name',
        'subject': 'Subject',
        'from': 'From',
        'from_name': 'From name',
        'to': 'To',
        'reply_to': 'Reply to',
        'attachments': 'Attachments',
        'content': 'Content',
        'project_name': 'Project',
        'smtp_provider_name': 'SMTP provider',
        'status': {
            'status': 'Status',
            'pending': 'Pending',
            'in_progress': 'In Progress',
            'max_retry_reached': 'Max Retry Reached',
            'sent': 'Sent'
        },
        'has_attachment': 'Has attachment',
        'retry_count': 'Retry count',
        'last_error': 'Last error',
        'uuid': 'UUID',
        'ignore_file_size_limit': 'Ignored file size limit',
        'confidential': 'Confidential'
    }
}
